import { Icon } from "./Icon";

export function DiscoverableSpaceIcon() {
  return <Icon name="discoverable-space" size={16} />;
}
